import { Component, input } from '@angular/core';

@Component({
  selector: 'era-title-h4',
  templateUrl: './title-h4.component.html',
})
export class TitleH4Component {
  readonly isDetail = input(false);
}
